/*eslint-disable*/
import { useEffect, useState } from 'react';
import type { FC } from 'react';
import {
  Link as RouterLink,
  useLocation,
  useNavigate
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';
import ChartPieIcon from '../../icons/ChartPie';
import Glossary from '../../icons/Glossary';
import ChartSquareBarIcon from '../../icons/ChartSquareBar';
import UsersIcon from '../../icons/Users';
import ContractIcon from '../../icons/Contract';
import UserIcon from '../../icons/User';
import BusinessIcon from '../../icons/Business';
import ProviderIcon from '../../icons/Provider';
import LogoR from '../LogoR';
import AssessmentIcon from '@material-ui/icons/Assessment';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import Imagen from '../../assets/img/logo-slogan-white.svg';

// Be sure to include styles at some point, probably during your bootstraping
import './sidebar.css';

interface DashboardSidebarProps {
  onMobileClose: () => void;
  openMobile: boolean;
}

const DashboardSidebar: FC<DashboardSidebarProps> = (props) => {
  const { onMobileClose, openMobile } = props;
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useTranslation('sidebar');
  const [menuExpanded, setMenuExpanded] = useState(false);
  let urlSplit = location.pathname.split('/');
  const [selectedMenu, setSelectedMenu] = useState(urlSplit ? urlSplit[urlSplit.length - 1] : 'dashboard');

  const sectionMaster = [
    {
      to: 'users',
      icon: (
        <UsersIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'users' ? '#ffad02' : '#af9fa4',
            marginLeft: '7px'
          }}
        />
      ),
      title: t('side.master.users')
    },
    {
      to: 'providers',
      icon: (
        <ProviderIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'providers' ? '#ffad02' : '#af9fa4',
            marginLeft: '10px'
          }}
        />
      ),
      title: t('side.master.suppliers')
    },
    {
      to: 'transactions',
      icon: (
        <AssessmentIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'transactions' ? '#ffad02' : '#af9fa4',
            marginLeft: '5px'
          }}
        />
      ),
      title: t('side.master.transactions')
    },
    {
      to: 'analytics',
      icon: (
        <ChartPieIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'analytics' ? '#ffad02' : '#af9fa4',
            marginLeft: '6px'
          }}
        />
      ),
      title: t('side.master.analytics')
    },
    {
      to: 'contract',
      icon: (
        <ContractIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'contract' ? '#ffad02' : '#af9fa4',
            marginLeft: '10px'
          }}
        />
      ),
      title: t('side.master.contracts')
    },
    {
      to: 'glossary',
      icon: (
        <Glossary
          fontSize="small"
          sx={{
            color: selectedMenu === 'glossary' ? '#ffad02' : '#af9fa4',
            marginLeft: '10px'
          }}
        />
      ),
      title: t('side.master.glossary')
    },
  ];

  const sectionEstandar = [
    {
      to: 'transactions',
      icon: (
        <AssessmentIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'transactions' ? '#ffad02' : '#af9fa4',
          }}
        />
      ),
      title: 'Transacciones y Reportería',
    },
    {
      to: 'analytics',
      icon: (
        <ChartPieIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'analytics' ? '#ffad02' : '#af9fa4',
          }}
        />
      ),
      title: 'FI & Analytics',
    },
  ];

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    let urlSplit = location.pathname.split('/');
    setSelectedMenu(urlSplit[urlSplit.length - 1]);
  }, [location.pathname]);

  return (
    <SideNav
      onSelect={(eventKey, event) => { }}
      onToggle={(expanded) => {
        setMenuExpanded(expanded);
      }}
    >
      <SideNav.Toggle
        style={{
          backgroundColor: '#0d2b47',
          width: '100%',
          borderBottom: menuExpanded ? '3px solid #ffae00' : '0px',
        }}
      />
      <SideNav.Nav>
        {!menuExpanded ? (
          <NavItem
            style={{
              borderBottom: '3px solid #ffae00',
              backgroundColor: '#0d2b47',
            }}
            eventKey="dashboard"
          >
            <NavIcon>
              <Box></Box>
              <LogoR />
            </NavIcon>
          </NavItem>
        ) : (
          <NavItem
            style={{
              borderBottom: '3px solid #ffae00',
              backgroundColor: '#0d2b47',
            }}
            eventKey="dashboard"
          >
            <NavIcon>
              <Box></Box>
              <img
                src={Imagen}
                style={{ marginLeft: 35, height: 50, width: 150 }}
                alt="website logo"
              />
            </NavIcon>
          </NavItem>
        )}
        <NavItem eventKey="dashboard">
          <NavIcon>
            <Tooltip sx={{ zIndex: 99 }} title="Dashboard" placement="right">
              <Button
                component={RouterLink}
                startIcon={
                  <ChartSquareBarIcon
                    sx={{
                      color:
                        selectedMenu === 'dashboard' ? '#ffad02' : '#af9fa4',
                      marginLeft: '7px'
                    }}
                    fontSize="small"
                  />
                }
                to={'/dashboard'}
              />
            </Tooltip>
          </NavIcon>
          <NavText>
            <Button
              component={RouterLink}
              to={'/dashboard'}
              sx={{
                color:
                  selectedMenu === 'dashboard'
                    ? '#ffad02 !important'
                    : '#af9fa4',
              }}
            >
              Dashboard
            </Button>
          </NavText>
        </NavItem>
        <NavItem eventKey="account">
          <NavIcon>
            <Tooltip sx={{ zIndex: 99, marginLeft: '3px' }} title="Mi Perfil" placement="right">
              <Button
                component={RouterLink}
                startIcon={
                  <UserIcon
                    fontSize="small"
                    sx={{
                      color: selectedMenu === 'account' ? '#ffad02' : '#af9fa4',
                    }}
                  />
                }
                to={'account'}
              />
            </Tooltip>
          </NavIcon>
          <NavText>
            <Button
              component={RouterLink}
              to={'account'}
              sx={{
                color:
                  selectedMenu === 'account' ? '#ffad02 !important' : '#af9fa4'
              }}
            >
              {t('side.master.profile')}
            </Button>
          </NavText>
        </NavItem>
        {user.isAdminUser === true && (
          <NavItem eventKey="business">
            <NavIcon>
              <Tooltip sx={{ zIndex: 99 }} title="Empresas" placement="right">
                <Button
                  component={RouterLink}
                  startIcon={
                    <BusinessIcon
                      fontSize="small"
                      sx={{
                        color:
                          selectedMenu === 'business' ? '#ffad02' : '#af9fa4',
                      }}
                    />
                  }
                  to={'business'}
                />
              </Tooltip>
            </NavIcon>
            <NavText>
              <Button
                component={RouterLink}
                to={'business'}
                sx={{
                  color:
                    selectedMenu === 'business'
                      ? '#ffad02 !important'
                      : '#af9fa4',
                }}
              >
                Empresas
              </Button>
            </NavText>
          </NavItem>
        )}
        {user.isAdminUser === false &&
          user.rol === 'master' &&
          sectionMaster.map((item, index) => (
            <NavItem key={`menusidebar-master${index}`} eventKey={item.to}>
              <NavIcon>
                <Tooltip
                  sx={{ zIndex: 99 }}
                  title={item.title}
                  placement="right"
                >
                  <Button
                    component={RouterLink}
                    startIcon={item.icon}
                    to={item.to}
                  />
                </Tooltip>
              </NavIcon>
              <NavText>
                <Button
                  component={RouterLink}
                  to={item.to}
                  sx={{
                    color:
                      selectedMenu === item.to
                        ? '#ffad02 !important'
                        : '#af9fa4',
                  }}
                >
                  {item.title}
                </Button>
              </NavText>
            </NavItem>
          ))}
        {user.isAdminUser === false &&
          user.rol === 'estandar' &&
          sectionEstandar.map((item, index) => (
            <NavItem key={`menusidebar-estandar${index}`} eventKey={item.to}>
              <NavIcon>
                <Tooltip
                  sx={{ zIndex: 99 }}
                  title={item.title}
                  placement="right"
                >
                  <Button
                    component={RouterLink}
                    startIcon={item.icon}
                    to={item.to}
                  />
                </Tooltip>
              </NavIcon>
              <NavText>
                <Button
                  component={RouterLink}
                  to={item.to}
                  sx={{
                    color:
                      selectedMenu === item.to
                        ? '#ffad02 !important'
                        : '#af9fa4',
                  }}
                >
                  {item.title}
                </Button>
              </NavText>
            </NavItem>
          ))}
        <NavItem eventKey="help">
          <NavIcon>
            <Button
              component={RouterLink}
              to={'help'}
            />
          </NavIcon>
          <NavText>
            <Button
              component={RouterLink}
              to={'help'}
              sx={{
                color:
                  selectedMenu === 'help' ? '#ffad02 !important' : '#af9fa4',
              }}
            >
              {t('side.master.needHelp')}
            </Button>
          </NavText>
        </NavItem>
      </SideNav.Nav>
    </SideNav>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default DashboardSidebar;
